import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Payment({ employee = {} }) {
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("AccountNo")}</div>
            <div className="form-value">
              <span>{employee?.AccountNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("OriginalBeneficiary")}
            </div>
            <div className="form-value">
              <span>{employee?.OriginalBeneficiary}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("PasswordToOpenPayslip")}
            </div>
            <div className="form-value">
              <span>{employee?.PasswordToOpenPayslip}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("BankName")}</div>
            <div className="form-value">
              <span>{employee?.BankName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("BankBranch")}</div>
            <div className="form-value">
              <span>{employee?.BankBranch}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <CheckBox
            defaultValue={employee?.IsBankTransfer}
            readOnly={true}
            text={formatMessage("IsBankTransfer")}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsReceivePayslipByEmail}
            readOnly={true}
            text={formatMessage("IsReceivePayslipByEmail")}
          />
        </div>
      </div>
    </div>
  );
}
